import { Button } from '@src/design-system/button';
import { PopoverTrigger } from '@src/design-system/popover';
import { Add } from 'iconsax-react';

const LabelsTrigger = () => {
  return (
    <PopoverTrigger asChild>
      <Button
        size='iconXs'
        variant='primaryPale'
        className='bg-primary-50 rounded-lg h-6 w-6 text-primary-1000 border-primary-1000'
      >
        <Add className='size-4 font-bold! text-primary-1000' />
      </Button>
    </PopoverTrigger>
  );
};

export default LabelsTrigger;
